import React from 'react';
import PropTypes from 'prop-types';

export default React.createClass({
  displayName: 'HelpLinks',
  propTypes: {
    user: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool,
    ]),
    params: PropTypes.object,
    isStudent: PropTypes.bool,
  },
  render() {
    if (this.props.user.anonymous) {
      return null;
    }

    const { user } = this.props;
    const { adminSubjects, teacherSubjects } = window.current_user;
    const { is_coordinator, is_teacher, is_admin: isAdmin } = user;

    const PreAP = 'PRE-AP';
    const AP = 'AP';

    const isAPTeacherOrAdmin = teacherSubjects.some(subject => (subject.subjectProgram === AP)) ||
        adminSubjects.some(subject => (subject.subjectProgram === AP));

    const currentUrl = window.location.href;
    const returnTo = window.btoa(currentUrl);

    const helpLinks = [];

    let role = '';
    if (is_teacher) role = 'teacher';
    if (is_coordinator || isAdmin) role = 'coordinator';
    if (isAPTeacherOrAdmin) {
        helpLinks.splice(1, 0, {
            href: `/n/pl?return=${returnTo}#/apclassroom${role}training`,
            title: 'AP Classroom Teacher Tutorials',
            target: '_blank'
        });
    }
    if (isAPTeacherOrAdmin && (is_coordinator || isAdmin)) {
      helpLinks.unshift({
        href: `/n/pl?return=${returnTo}#/apclassroomcoordinatortraining`,
        title: 'AP Coordinator System Tutorials',
        target: '_blank'
      });
    }

    return  (
      <div className="help_links" style={{marginBottom: '1.5rem'}}>
        { (helpLinks.length > 0) && <h4> Tutorials </h4> }
        <ul>
          {helpLinks.map((l, i) => (
            <li key={i}>
              <a href={l.href} target='_blank' key={i}>{l.title}</a>
            </li>
          ))}
        </ul>
        <hr/>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/controls/HelpLinks.jsx
 **/